import {initI18n} from "./localTranslate";
import {loadScriptOrIgnore} from "../../loadScript";

export const formatToI18n: any = (obj: any) => {
    return Object.keys(obj).reduce((acc, ele) => {
        return {
            ...acc,
            [ele]: typeof obj[ele] === 'string'? obj[ele].replace(/\{([0-9])}/g, "{{$1}}") :formatToI18n(obj[ele])
        }
    }, {})
}

export const getCorrectTranslate = (ele: string, base: any, custom: any, path: string[] = []) => {
    try {
        const dataCustom = path.reduce((obj: any, key: string) => obj?.[key], custom)?.[ele];
        return dataCustom ? dataCustom : base[ele]
    } catch (err) {
        console.error("i18n merge fallback on key", [...path, ele].join("."), err);
        return base?.[ele]
    }
}

export const mergeI18n: any = (base: any, custom: any, path: string[] = []) => {
    return Object.keys(base).reduce((acc, ele) => {
        const currentPath = [...path, ele];
        const baseValue = base?.[ele];
        let mergedValue;

        try {
            mergedValue = typeof baseValue === 'string'
                ? getCorrectTranslate(ele, base, custom, path)
                : mergeI18n(baseValue, custom, currentPath)
        } catch (err) {
            console.error("i18n merge recursion fallback on key", currentPath.join("."), err);
            mergedValue = baseValue
        }

        return {
            ...acc,
            [ele]: mergedValue
        }
    }, {})
}

export const getDynamicLanguage = (lang: string) => {
    return new Promise((resolve ) => {
        if(process.env.REACT_APP_LOAD_CONFIG){
            Promise.all([loadScriptOrIgnore(`${process.env.REACT_APP_LOAD_CONFIG}base/translate/${lang}.js`), loadScriptOrIgnore(`${process.env.REACT_APP_LOAD_CONFIG}translate/${lang}.js`)]).then(res => {
                const translation = mergeI18n((window as any).translateBase[lang], (window as any).translateCustom[lang]);
                resolve(translation)
            })
        } else {
            resolve(initI18n[lang] || {})
        }

    } )
}
